import { gql } from '@apollo/client';

const schema = {
  shipping: {
    name: 'shipping',
    serviceName: 'auth',
    query: gql`
      query shipping($shop_ids: [String], $is_active: Int, $for_admin: Int) {
        shipping(shop_ids: $shop_ids, is_active: $is_active, for_admin: $for_admin) {
          data {
            id
            type {
              title
            }
          }
        }
      }
    `,
  },
  changeShipping: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $shipping_id: String) {
        updateOrder(ids: $ids, shipping_id: $shipping_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
